import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const authClient = axios.create({ baseURL: API, withCredentials: true });

export const adminLogin = async (email, password) => {
  const res = await authClient.post("/auth/login", { email, password });
  return res.data;
};

export const adminLogout = async () => {
  try { await authClient.post("/auth/logout"); } catch { /* ignore */ }
};

export const fetchMe = async () => (await authClient.get("/auth/me")).data;
export const fetchOverview = async () => (await authClient.get("/admin/overview")).data;
export const fetchBookings = async (status) => (await authClient.get("/admin/bookings", { params: status ? { status } : {} })).data;
export const cancelBooking = async (ref) => (await authClient.post(`/admin/bookings/${ref}/cancel`)).data;
export const reinstateBooking = async (ref) => (await authClient.post(`/admin/bookings/${ref}/reinstate`)).data;
export const fetchCustomers = async () => (await authClient.get("/admin/customers")).data;
export const fetchTraffic = async () => (await authClient.get("/admin/traffic")).data;
export const fetchAdminCars = async () => (await authClient.get("/admin/cars")).data;
export const createCar = async (payload) => (await authClient.post("/admin/cars", payload)).data;
export const updateCar = async (slug, payload) => (await authClient.put(`/admin/cars/${slug}`, payload)).data;
export const deleteCar = async (slug) => (await authClient.delete(`/admin/cars/${slug}`)).data;

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await authClient.post("/admin/upload", fd);
  return res.data.url;
};

export const changePassword = async (current_password, new_password) =>
  (await authClient.post("/auth/change-password", { current_password, new_password })).data;
export const fetchCarSchedule = async (slug) => (await authClient.get(`/admin/cars/${slug}/schedule`)).data;
export const addBlock = async (slug, payload) => (await authClient.post(`/admin/cars/${slug}/blocks`, payload)).data;
export const deleteBlock = async (id) => (await authClient.delete(`/admin/blocks/${id}`)).data;
